import AccountCreatedPage from './AccountCreatedConnector';

export default AccountCreatedPage;
